import InitLazyComponent from 'Modules/InitLazyComponent';
import TrustpilotBanner from './components/TrustpilotBanner.vue';
import ReviewsArchive from './components/ReviewsArchive.vue';
import ReviewsCarousel from './components/ReviewsCarousel.vue';
import CounselorReviews from './components/CounselorReviews.vue';
import PlatformBadges from './components/PlatformBadges.vue';
import store from 'Stores/store';

const banners = document.querySelectorAll('.trustpilot-banner__vue');
const archive = document.getElementById('reviews-archive__vue');
const counselor = document.getElementById('counselor-reviews__vue');
const carousels = document.querySelectorAll('.reviews-carousel');
const platformBadgesMounts = document.querySelectorAll('.platform-badges-block');

if (banners) {
  const bannerInstance = new InitLazyComponent({
    selectors: banners,
    components: { TrustpilotBanner },
    template: '<TrustpilotBanner />',
    store,
  });

  bannerInstance.init();
}

if (archive) {
  const archiveInstance = new InitLazyComponent({
    selectors: archive,
    components: { ReviewsArchive },
    template: '<ReviewsArchive />',
    store,
  });

  archiveInstance.init();
}

if (counselor) {
  const counselorInstance = new InitLazyComponent({
    selectors: counselor,
    components: { CounselorReviews },
    template: '<CounselorReviews />',
    store,
  });

  counselorInstance.init();
}

if (carousels) {
  const carouselInstance = new InitLazyComponent({
    selectors: carousels,
    components: { ReviewsCarousel },
    template: '<ReviewsCarousel />',
    store,
  });

  carouselInstance.init();
}

if (platformBadgesMounts.length) {
  const platformBadgesInstance = new InitLazyComponent({
    selectors: platformBadgesMounts,
    components: { PlatformBadges },
    template: `<PlatformBadges
      :average-rating="$mountEl.dataset.averageRating || ''"
      :number-of-ratings="$mountEl.dataset.numberOfRatings || ''"
      :reviews-url="$mountEl.dataset.reviewsUrl || ''"
      :reco-widget-src="$mountEl.dataset.recoWidgetSrc || ''"
      :reco-mount-id="$mountEl.dataset.recoMountId || 'reco--badge-2026'"
      :google-rating="$mountEl.dataset.googleRating || ''"
    />`,
    store,
  });

  platformBadgesInstance.init();
}
